import { environmentHttpClient } from "client/Api/httpClient";
import { EditorModes, OpenWacModel } from "../common";
import { ListLocationModel } from "./common";

export function officeInterfaceEditorModel(
	location: ListLocationModel,
	fileId: number,
	editorMode: EditorModes | undefined,
	async: boolean,
	signal?: AbortSignal
): Promise<OpenWacModel> {
	return environmentHttpClient.get<OpenWacModel>(
		"Documents/SharePoint/FileEditor/OfficeInterfaceEditorModel",
		{
			fileId,
			location,
			editorMode
		},
		{ async, signal }
	);
};


export function sharepointViewerUrl(
	location: ListLocationModel,
	fileId: number,
	signal?: AbortSignal
): Promise<string> {
	return environmentHttpClient.get<string>(
		"Documents/SharePoint/FileEditor/SharepointViewerUrl",
		{ fileId, location },
		{ signal }
	);
};
